import React, {useState} from "react";
import {Form, Input, Switch} from "antd";

export const FormItem = (props) => {
    const [isFieldActive, toggleIsFieldActive] = useState(false);
    // let isFieldActive = false
    // const toggleIsFieldActive = (state) => (isFieldActive = state)
    const requiredMark = (<span style={{color: "red", margin: "3% 0% 0% 3%"}}>*</span>)

    return (<div className={props.className ? props.className : "col"}>
        <label
            className="font-weight-bold text-nowrap">{props.label}{props.required ? requiredMark : ''}
        </label>
        {props.addButton
            ?
            <div className={"d-flex align-items-center justify-content-between position-relative"}
                 style={{gap: "3%"}}>
                <div className={"cd-ant-form-item-wrapper"}>
                    <Form.Item>
                        <Switch
                            unCheckedChildren="NO"
                            checkedChildren="YES"
                            checked={isFieldActive}
                            onChange={() => toggleIsFieldActive(!isFieldActive)}
                        >
                            Form disabled
                        </Switch>
                    </Form.Item>
                </div>

                {props.children ?
                    <div className={"cd-ant-form-item-wrapper flex-grow-1"}>
                        <Form.Item>
                        <span
                            className={!isFieldActive
                                ? "cd-ant-form-item-child-disabled"
                                : null}
                        >
                            {props.children}
                        </span>
                        </Form.Item>
                    </div> : ""}

            </div>

            : <Form.Item
                name={props.formItemName}
                rules={
                    props.rules ? [...props.rules] : [
                        {
                            required: props.required,
                            message: 'Please input ' + props.label
                        }
                    ]
                }
            >
                {
                    props.inputType !== "select"
                        ? <Input type={props.inputType}
                                 placeholder={props.placeholder ? props.placeholder : (`Enter ${props.label}`)}/>
                        : <>
                            {props.children}
                        </>
                }
            </Form.Item>}
    </div>)
}